<template>
    <div class="pb-5 border-b border-gray-2">
        <div class="flex pb-2">
            <img class="m-auto" src="@/assets/icon/ic-confirm.png" alt=""/>
        </div>
        <div class="text-22 text-gray-1">{{campaign.name}}</div>
        <div class="text-22 text-blue-1">{{getPointTxt()}}</div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'DeliveryConfirmRedeem',
    mixins: [LocaleMixin],
    props: {
        campaign: Object
    },
    data: function () {
        return {
            msg: ''
        };
    },
    created: function () {
        let minutes = this.campaign.minutesValidAfterUsed;
        if (minutes) {
            let days = '';
            let hours = '';
            let result = '';
            if (minutes >= 60) {
                hours = Math.floor(minutes / 60);
                if (hours >= 24) {
                    days = Math.floor(hours / 24);
                }
            }

            if (days > 0) {
                result += days + ' ' + this.lbl.date.days + ' ';
            }

            if (hours / 24 > 0) {
                result += (hours % 24) + ' ' + this.lbl.date.hours + ' ';
            }

            if (minutes / 60 > 0) {
                result += (minutes % 60) + ' ' + this.lbl.date.minutes_short;
            }

            this.msg = Util.stringFormat(this.lbl.confirm_redeem.defualt_have_time, result);
        } else {
            this.msg = this.lbl.confirm_redeem.default;
        }
    },
    methods: {
        getPointTxt: function () {
            let pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            let pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.FilterNumberFormat(this.campaign.pointPerUnit)} ${pointUnit}`;
        },
    }
}
</script>
